import { httpRequest } from '@/apis/request'
import { response } from '@/apis/types'

enum Apis {
  userAccess = 'sk/keys',
}

/** @description 删除用户访问令牌 */
export const deleteUserAccessToken = (id: string) => {
  return httpRequest.delete<response<{ message: string }>>(
    Apis.userAccess + '/' + id
  )
}
/** @description 添加用户访问令牌 */
export const createUserAccessToken = (data: any) => {
  return httpRequest.post<response<{ message: string }>>(Apis.userAccess, data)
}
